import React from 'react';

import { Collapse } from '@material-ui/core';
import moment from 'moment';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { Flight } from 'models/flight';

import FlightDetailCard from '../../FlightDetailCard';
import { formatDuration } from '../../utils';
import { FlightDetailCardWrapper } from './styles';
import TimeBetweenFlights from './TimeBetweenFlights';

interface Props {
  expanded: boolean;
  flights: Flight[];
  totalDuration: string;
}

const CollapsibleDetail = ({ expanded, flights, totalDuration }: Props) => {
  const { t } = useStoreTranslation();
  return (
    <Collapse in={expanded} unmountOnExit={true}>
      <FlightDetailCardWrapper>
        {flights.map((flight, idx) => {
          const isLastFlight = idx + 1 === flights.length;
          const nextFlight = flights[idx + 1];
          return (
            <React.Fragment key={flight.number}>
              <FlightDetailCard flight={flight} />
              <TimeBetweenFlights isLastFlight={isLastFlight}>
                {isLastFlight
                  ? t('flightsCard.detailCard.totalDurationLabel', { duration: formatDuration(totalDuration) })
                  : t('flightsCard.detailCard.stopDurationLabel', {
                      cityName: flight.arrivalAirport,
                      duration: formatDuration(
                        moment.duration(moment(nextFlight.departureDate).diff(moment(flight.arrivalDate))).asSeconds(),
                        'seconds',
                      ),
                    })}
              </TimeBetweenFlights>
            </React.Fragment>
          );
        })}
      </FlightDetailCardWrapper>
    </Collapse>
  );
};

export default CollapsibleDetail;
